import { LoginRequest } from "../../api";
import * as ReduxToolkit from "@reduxjs/toolkit";

export interface State {
    login: LoginRequest;
}

export function initState(): State {
    return {
        login: {
            consoleUserId: "",
            password: "",
            otpToken: "",
            token: "",
        },
    };
}

export const loginSlice = ReduxToolkit.createSlice({
    name: "login",
    initialState: initState(),
    reducers: {
        resetState: (state) => {
            state = initState();
            return state;
        },
        setLogin(state, action: ReduxToolkit.PayloadAction<LoginRequest>) {
            state.login = action.payload;
            return state;
        },
    },
});
